import { useEffect } from "react";
import { useNavigate } from "react-router";

const Main = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      navigate("/login");
    }
  }, []);

  return (
    <div>
      <div>this is main page</div>
    </div>
  );
};

export default Main;
